import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ADD, REMOVE, SIDEBAR_ICON, VIEW_TYPES } from "../../common/constant/common-constants";
import AnimateBed from "../../common/utils/Animations/AnimateBed";
import MonitorDetail from "../MonitorDetail/MonitorDetail";
import { bedDetailAction, favoriteBedAction, viewTypeAction, wardDetailsAction } from "../../modules/actions/action";
import BedDataContainer from "../BedDataContainer/BedDataContainer";
import BedListContainer from "../BedListContainer/BedListContainer";
import { PatientModal } from "../PatientModal/PatientModal";
import PatientBookContainer from '../PatientBookContainer/PatientBookContainer';

import "./BedContainer.scss";

function BedContainer(props) {

    const [lvSelectedBed, setLvSelectedBed] = useState(null);
    const [bedArray, setBedArray] = useState(props.bedIdArray);

    useEffect(() => {
        props.viewTypeAction({ viewType: VIEW_TYPES.LIST_VIEW });
        const favBedArray = props.favoriteBedIdArray;
        let bd = (bedArray && bedArray.sort((a, b) => favBedArray.indexOf(b) - favBedArray.indexOf(a))) || [];
        setBedArray([...bd]);
    }, [props.favoriteBedIdArray])

    useEffect(() => {
        setBedArray(props.bedIdArray);

        if (props.bedIdArray && props.bedIdArray.length > 0) {
            if (!lvSelectedBed) setLvSelectedBed(props.bedIdArray[0]);
        }
    }, [props.bedIdArray])

    const handleFavoriteClick = (event, type, bedId) => {

        event.stopPropagation();

        let arr = props.favoriteBedIdArray;
        let index = arr.indexOf(bedId);
        switch (type) {
            case ADD:
                if (arr.indexOf(bedId) < 0) {
                    arr.push(bedId);
                }
                break;
            case REMOVE:
                if (index > -1) {
                    arr.splice(index, 1);
                }
                break;
            default:
                break;
        }

        props.favoriteBedAction([...arr]);

        // setFavArray([...arr]);
    }

    const handleNotificationClick = (bedId) => {
        console.log(`notification icon clicked for ${bedId}`);
    }

    const handleBedClick = (id) => {

        console.log("clicked on item :: " + id);
        setLvSelectedBed(id);
    }

    const getBedArray = () => {

        if (bedArray === null) return;
        let tempBedArray = [...bedArray];
        let html = tempBedArray.map((id) => {

            // let wardId = props.selectedWard.id;

            if (props.wardData && props.wardData.bedList && (props.wardData.bedList.indexOf(id) >= 0)) {
                let ref = React.createRef();
                return (
                    <BedDataContainer
                        key={id}
                        bedId={id}
                        handleFavoriteClick={(event, type, bedId) => handleFavoriteClick(event, type, bedId)}
                        isFavorite={props.favoriteBedIdArray && props.favoriteBedIdArray.indexOf(id) > -1}
                        isSelected={lvSelectedBed && lvSelectedBed === id}
                        viewType={props.config.viewType}
                        handleBedClick={() => handleBedClick(id)}
                        handleNotificationClick={(bedId) => handleNotificationClick(bedId)}
                        ref={ref}
                    />);
            }
        });
        return html;
    }

    return (
        <>
            {/* {console.log("rerendering BedContainer !!!")} */}
            <div className="bed-container">

                {/* {props.config && props.config.viewType === VIEW_TYPES.GRID_VIEW && <div className='bed-grid-data-container'>
                    <AnimateBed >
                        {
                            getBedArray()
                        }
                    </AnimateBed>
                </div>} */}
                {
                    props.config.viewType === VIEW_TYPES.LIST_VIEW && <div className='bed-list-data-container'>

                        {/* <div className='bed-list-card'>
                            {getBedArray()}
                        </div> */}

                        {/* <BedListContainer wardData={props.wardData} /> */}
                        {props.config.activeSidebarIcon === SIDEBAR_ICON.HOME_PAGE && <BedListContainer wardData={props.wardData} />}
                        {props.config.activeSidebarIcon === SIDEBAR_ICON.PATIENT_BOOK && <PatientBookContainer wardData={props.wardData} />}

                        {/* <div className='bed-list-data'>
                            {
                                // lvSelectedBed && <GraphDetail bedId={lvSelectedBed} />
                                <BedListContainer />

                            }
                        </div> */}
                    </div>
                }
            </div>
        </>
    );
}

const mapStateToProps = (state, ownProps) => {

    let wardData = state.wardDetailsReducer.wardData && state.wardDetailsReducer.wardData[ownProps.selectedWard.id];
    return {
        // bedDetails: state.bedDetailsReducer.bedDetails,
        bedIdArray: state.bedDetailsReducer.bedIdArray,
        wardData: wardData,
        config: state.configReducer.config,
        favoriteBedIdArray: state.bedDetailsReducer.favoriteBedIdArray || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        bedDetailAction: (payload) => dispatch(bedDetailAction(payload)),
        wardDetailAction: (payload) => dispatch(wardDetailsAction(payload)),
        favoriteBedAction: (payload) => dispatch(favoriteBedAction(payload)),
        viewTypeAction: (payload) => dispatch(viewTypeAction(payload))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BedContainer);


// {console.log("rerendering BedContainer !!!")}
//             <div className="bed-container">

//                 {props.config.viewType === VIEW_TYPES.GRID_VIEW && <div className='bed-grid-data-container'>
//                     {/* <AnimateBed > */}
//                     {
//                         getBedArray()
//                     }
//                     {/* </AnimateBed> */}
//                 </div>}
//                 {
//                     props.config.viewType === VIEW_TYPES.LIST_VIEW && <div className='bed-list-data-container'>

//                         <div className='bed-list-card'>
//                             {getBedArray()}
//                         </div>
//                         <div className='bed-list-data'>
//                             {
//                                 lvSelectedBed && <MonitorDetail data={lvSelectedBed} />
//                             }
//                         </div>
//                     </div>
//                 }
//             </div>